import {FC} from 'react';
import classNames from 'classnames';
import styles from './SearchAd.module.scss';

export const DetailAd: FC = ({children}) => (
    <div className={classNames(styles.contentAd, 'contentAd')}>
        <div className={styles.contentDetailAdHolder}>{children}</div>
    </div>
);
